
import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

export default function FAQ({ id }: { id?: string }) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqs: FAQItem[] = [
    {
      question: 'How much time will this take for our staff?',
      answer: 'About 10–15 minutes per issue to review the final proof for brand alignment. Optionally, you can submit local updates via a simple form. We handle everything else — editorial, design, sponsor sales, billing, and distribution.'
    },
    {
      question: 'Do you collect any resident health information (PHI)?',
      answer: 'No. We do not request or collect PHI, resident lists, emails, phone numbers, or any health information. We only need your facility branding and optional event updates you choose to share.'
    },
    {
      question: 'How are sponsors selected and labeled?',
      answer: 'Harmony Horizon contracts with sponsors and manages all sales and billing. All sponsor placements are clearly labeled "Sponsored." We may reject categories or claims that don\'t meet healthcare advertising standards.'
    },
    {
      question: 'Does our facility pay anything or receive sponsorship revenue?',
      answer: 'Your facility pays $0 and does not receive sponsorship revenue. Sponsor placements fund production costs. Harmony Horizon handles all sponsor contracts and billing — you simply review the final proof.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section id={id} className="py-10 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Frequently asked questions
          </h2>
          <p className="text-base text-gray-600">
            Clear answers to common questions.
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="bg-gray-50 border border-gray-200 rounded-lg overflow-hidden hover:border-purple-300 hover:bg-white transition-all duration-300"
            >
              <button 
                onClick={() => toggleFAQ(index)}
                className="w-full px-5 py-4 flex items-center justify-between text-left cursor-pointer"
              >
                <h3 className="text-base font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i className={`ri-arrow-down-s-line text-xl text-purple-600 transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'transform rotate-180' : ''}`}></i>
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-5 pb-4">
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
